module.exports = __webpack_public_path__ + "static/Zendesk-bd10fcd5f3e1743f54031b4db4698c10.png";